import type {ChatMessagePart, ImagePart} from '@Components/ai-chat-window/ai-chat-window.types';
import {ChatMessagePartType} from '@Components/ai-chat-window/ai-chat-window.types';

export interface UserAttachmentProps {
  part: ChatMessagePart;
  partKey: string;
  onImageClick: (uniqueKey: string) => void;
  onReattach: (part: ImagePart, previewUrl?: string) => void;
  isMobile?: boolean;
}

export const isImagePart = (part: ChatMessagePart): part is ImagePart => {
  return (
    part.type === ChatMessagePartType.USER_IMAGE ||
    part.type === ChatMessagePartType.DESIGN ||
    part.type === ChatMessagePartType.MODEL_GENERATED_IMAGE ||
    part.type === ChatMessagePartType.IMAGE_GRAPHIC_ITEM_SNAPSHOT ||
    part.type === ChatMessagePartType.EXAMPLE_IMAGE_ASSET ||
    part.type === ChatMessagePartType.REATTACHED_MODEL_IMAGE
  );
};
